<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3">
        <label>Estabelecimento</label>
        <v-select
          label="sie_estabelecimento"
          :options="estabelecimentos"
          v-model="estabelecimentoEntity"
          @input="onLoadDayData"
          :disabled="Object.keys(this.estabelecimento).length > 0"
        >
          <template slot="no-options">Pesquise estabelecimentos pela razão social</template>
        </v-select>
      </div>
      <div class="col-md-3">
        <label>Data</label>
        <input type="date"
          v-model="selectedDate"
          class="form-control"
          @change="onSelectDay"
        />
        <!-- <datepicker-component
          v-model="selectedDate"
          input-class="form-control"
          @change="onSelectDay"
        ></datepicker-component> -->
      </div>
      <div class="col-md-2">
        <label>&nbsp;</label>
        <button
          class="btn btn-primary"
          :disabled="!canMakeChanges"
          @click="onAddItemClick"
        >Adicionar registro</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <xlsx-report-component
          module="acompanhamentos"
          controller="recebimento-leite-report"
          modal-title="Gerar relatório mensal"
          button-text="Gerar relatório mensal"
          :disabled="!selectedDate || (!estabelecimentoEntity || !estabelecimentoEntity.cod_estabelecimento) || !items.length"
        >
          <input type="hidden" name="type" value="monthly" />
          <input
            type="hidden"
            name="data"
            :value="selectedDate && selectedDate.indexOf('-') == -1 ? selectedDate.split('/').reverse().join('-'): selectedDate"
          />
          <input
            type="hidden"
            name="cod_estabelecimento"
            :value="estabelecimentoEntity && estabelecimentoEntity.cod_estabelecimento"
          />
        </xlsx-report-component>
      </div>
      <div class="col-md-3">
        <xlsx-report-component
          module="acompanhamentos"
          controller="recebimento-leite-report"
          modal-title="Gerar relatório do dia"
          button-text="Gerar relatório do dia"
          :disabled="!selectedDate || (!estabelecimentoEntity || !estabelecimentoEntity.cod_estabelecimento) || !items.length"
        >
          <input type="hidden" name="type" value="diary" />
          <input
            type="hidden"
            name="data"
            :value="selectedDate && selectedDate.indexOf('-') == -1 ? selectedDate.split('/').reverse().join('-'): selectedDate"
          />
          <input
            type="hidden"
            name="cod_estabelecimento"
            :value="estabelecimentoEntity && estabelecimentoEntity.cod_estabelecimento"
          />
        </xlsx-report-component>
      </div>
    </div>
    <div class="row mt-2" v-if="boletos.length">
      <div class="col-md-12">
        <h3>Boletos do mês</h3>
      </div>
      <div class="col-md-2" v-for="(boleto, index) in boletos" :key="index">
        <p class="text text-center">
          <i class="fa fa-file-pdf-o fa-4x"></i>
          <label class="text text-center">{{ boleto.description }}</label>
          <label class="text text-center">
            Status:
            <b
              :class="{text: true, 'text-success': boleto.pago, 'text-danger': !boleto.pago}"
            >{{ boleto.pago ? 'Pago' : 'Não pago' }}</b>
          </label>
          <a :href="boleto.link" class="text text-primary text-center" target="_blank">
            <i class="fa fa-download"></i> Baixar
          </a>
        </p>
      </div>
    </div>
    <div
      class="no-data-found mt-1"
      v-if="!selectedDate || !this.estabelecimentoEntity || !this.estabelecimentoEntity.cod_estabelecimento"
    >
      <i class="fa fa-exclamation-circle"></i>
      <p>Selecione o dia e o estabelecimento</p>
    </div>
    <div class="no-data-found mt-1" v-else-if="isLoading">
      <i class="fa fa-spinner fa-pulse fa-fw"></i>
      <p>Carregando...</p>
    </div>
    <div class="no-data-found mt-1" v-else-if="items.length === 0">
      <i class="fa fa-exclamation-circle"></i>
      <p>Nenhum registro encontrado.</p>
    </div>
    <div class="mt-2" v-else>
      <div class="sida-accordion">
        <div
          v-for="(item, index) in items"
          :key="index"
          :class="{item, active: index === activeItem}"
          class="accordion-item"
          :data-index="index"
          :id="'accordion-' + index"
        >
          <h1 class="accordion-title" @click="onChangeAccordion(index)">
            {{ item.tipo_produto == 'leite' ? (item.nome_produtor ? item.nome_produtor : 'Produtor '+index+1) : item.cnpj_fabricante ? item.cnpj_fabricante+' | '+item.tipo_registro.toUpperCase()+': '+item.numero_registro : 'Produtor '+(index+1) }}
            <button
              class="btn btn-delete"
              @click="onDeleteClick($event, index)"
              :disabled="!canMakeChanges"
            >
              <i class="fa fa-trash"></i>
            </button>
          </h1>
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group required">
                    <label>Tipo de produto</label>
                    <select
                      class="form-control"
                      v-model="item.tipo_produto"
                      @change="setAlterado()"
                    >
                      <option value>Selecione</option>
                      <option value="leite">Leite in-natura</option>
                      <option value="beneficiado">Beneficiados</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row" v-show="item.tipo_produto=='leite'">
                <div class="col-md-4">
                  <div class="form-group"
                  :class="{ required: item.tipo_produto=='leite' }">
                    <label>Estado</label>
                    <select
                      class="form-control"
                      v-model="item.estado"
                      @input="onInputEspecie($event, item)"
                      :disabled="!canMakeChanges"
                      @change="setAlterado()"
                    >
                      <option value="ceara">Ceará</option>
                      <option value="outros">Outros</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group"
                  :class="{ required: item.tipo_produto=='leite' }">
                    <label>CPF/CNPJ do produtor</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.cpf_cnpj_produtor"
                      v-mask="['###.###.###-##', '##.###.###/####-##']"
                      @blur="onCpfCnpjBlur(item)"
                      :disabled="!canMakeChanges"
                      @keyup="setAlterado()" @keydown="setAlterado()"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group"
                  :class="{ required: item.tipo_produto=='leite' }">
                    <label>Nome do produtor</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.nome_produtor"
                      :disabled="item.is_produtor_sidagro || !canMakeChanges"
                      @keyup="setAlterado()" @keydown="setAlterado()"
                    />
                  </div>
                </div>
              </div>
              <div class="row" v-show="item.tipo_produto=='leite'">
                <div class="col-md-4">
                  <div class="form-group"
                  :class="{ required: item.tipo_produto=='leite' }">
                    <label>Espécie</label>
                    <select
                      class="form-control"
                      v-model="item.cod_especie"
                      @input="onInputEspecie($event, item)"
                      :disabled="!canMakeChanges"
                      @change="setAlterado()"
                    >
                      <option value>Selecione</option>
                      <option
                        class="form-control"
                        v-for="especie of dadosLeite.especies"
                        :key="especie.cod"
                        :value="especie.cod"
                      >{{ especie.nome }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4" v-show="item.estado=='outros'">
                  <div class="form-group"
                  :class="{ required: item.estado=='outros' && item.tipo_produto=='leite' }">
                    <label>Nome da propriedade</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.nome_propriedade"
                      @keyup="setAlterado()" @keydown="setAlterado()"
                    />
                  </div>
                </div>
                <div class="col-md-4" v-show="item.estado=='ceara'">
                  <div class="form-group"
                  :class="{ required: item.tipo_produto=='leite' && item.estado!='outros' }">
                    <label>Propriedade</label>
                    <select
                      class="form-control"
                      v-model="item.cod_propriedade"
                      @change="onChangePropriedade(item)"
                      :disabled="!canMakeChanges"
                    >
                      <option value>Selecione</option>
                      <option
                        v-for="(propriedade, index) in item.propriedades"
                        :key="index"
                        :value="propriedade.cd_propriedade"
                      >{{ propriedade.nm_pessoa }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group"
                  :class="{ required: item.tipo_produto=='leite' }">
                    <label>Quantidade recebida (Litros)</label>
                    <input
                      type="text"
                      class="form-control"
                      v-numeric
                      v-model="item.qtd_recebida"
                      :disabled="(!item.is_produtor_sidagro && item.estado=='ceara') || (!item.is_adimplente_febre_aftosa && item.estado=='ceara') || !canMakeChanges"
                      @keyup="setAlterado()" @keydown="setAlterado()"
                    />
                  </div>
                </div>
              </div>
              
              <div class="row" v-show="item.tipo_produto=='beneficiado'">
                <div class="col-md-4">
                  <div class="form-group" :class="{ required: item.tipo_produto=='beneficiado' }">
                    <label>CNPJ do fabricante</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.cnpj_fabricante"
                      v-mask="['##.###.###/####-##']"
                      :disabled="!canMakeChanges"
                      @blur="onCpfCnpjBlur(item)"
                      @keyup="setAlterado()" @keydown="setAlterado()"
                    />
                  </div>
                  <template v-if="(item.cnpj_fabricante) && (item.cnpj_fabricante.length < 18)">
                    <span class="text text-danger">Insira um CNPJ válido</span>
                    <!-- VALIDATION PURPOSE: -->
                    <div class="form-group required">
                      <input
                        type="hidden"
                        class="form-control"
                      />
                    </div>
                  </template>
                </div>
                <div class="col-md-4">
                  <div class="form-group" :class="{ required: item.tipo_produto=='beneficiado' }">
                    <label>Tipo de registro</label>
                    <select
                      class="form-control"
                      v-model="item.tipo_registro"
                      @change="setAlterado()"
                    >
                      <option value>Selecione</option>
                      <option value="sie">SIE</option>
                      <option value="sif">SIF</option>
                      <option value="sim-sisbi">SIM/SISBI</option>
                      <option value="sie-sisbi">SIE/SISBI</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group" :class="{ required: item.tipo_produto=='beneficiado' }">
                    <label>Numero do registro</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.numero_registro"
                      @keyup="setAlterado()" @keydown="setAlterado()"
                    />
                  </div>
                </div>
                
              </div>
              <div class="row" v-show="item.tipo_produto=='beneficiado'">
                <div class="col-md-4">
                  <div class="form-group" :class="{ required: item.tipo_produto=='beneficiado' }">
                    <label>Produto</label>
                    <select
                      class="form-control"
                      v-model="item.produto"
                      @change="()=>{item.qtd_recebida = ''; alteracoes = true;}"
                    >
                      <option value="">Selecione</option>
                      <option
                        class="form-control"
                        v-for="tipo of dadosLeite.beneficiados"
                        :key="tipo.cod_beneficiado"
                        :value="tipo.cod_beneficiado"
                      >{{ tipo.nome }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group"
                  :class="{ required: item.tipo_produto=='beneficiado' }">
                    <label>Quantidade recebida (Kg)</label>
                    <input
                      type="text"
                      class="form-control"
                      v-numeric
                      v-model="item.qtd_recebida"
                      :disabled="!canMakeChanges"
                      @keyup="setAlterado()" @keydown="setAlterado()"
                    />
                  </div>
                </div>
              </div>
              <!-- <fieldset class="sida-fieldset m-0 my-1" v-show="item.tipo_produto=='beneficiado'">
                <legend>Derivadas</legend>
                <span class="text text-upper"><b class="text text-danger">*</b> Para preenchimento no caso de a empresa utilizar <b>derivados de leite</b> como matéria-prima.</span>
                <qtd-and-select-component
                  :value="item.derivadas"
                  selectName="causa_derivada"
                  qtdText="Quantidade (KG)"
                  :options="getDerivadasOptions(item)"
                  
                  :maxQtdSomatory="item.qtd_recebida"
                  :showTotal="true"
                ></qtd-and-select-component>
              </fieldset> -->

              <fieldset class="sida-fieldset m-0 my-1" v-show="!item.tipo_produto==''">
                <legend>Não-conformidades</legend>
                <qtd-and-select-index-component
                  :value="item.naoConforme"
                  selectName="cod_nao_conformidade"
                  :qtdText="item.tipo_produto == 'leite' ? 'Quantidade (Litros)' : 'Quantidade (KG)'"
                  :options="naoConformidadeOptions(item.produto)"
                  cod="cod_nao_conformidade"
                  :disabled="!canMakeChanges"
                  :maxQtdSomatory="item.qtd_recebida"
                  :showTotal="true"
                ></qtd-and-select-index-component>
              </fieldset>
              
              <div class="row" v-show="!item.tipo_produto==''">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Observações</label>
                    <textarea class="form-control" cols="30" rows="10" v-model="item.observations" @keyup="setAlterado()" @keydown="setAlterado()"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-sm-2">
        <input
          type="button"
          value="Pesquisar"
          name="Pesquisar"
          @click="pesquisar()"
          class="ui-button"
          v-show="!this.isuser"
        />
      </div>
      <div class="col-sm-10">
        <div class="d-flex flex-row-reverse">
          <div class="d-flex justify-content-end">
            <input
              type="submit"
              value="Salvar"
              name="Salvar"
              class="btn"
              :disabled="disableSaveButton"
              @click="onSaveClick"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    estabelecimento: {
      required: false,
    },
    estabelecimentos: {
      required: true,
    },
    isuser: Number,
  },
  data: () => ({
    selectedDate: null,
    isLoading: false,
    estabelecimentoEntity: null,
    requestSource: null,
    searchTimeoutId: null,
    dadosLeite: [],
    items: [],
    boletos: [],
    deletedLeite: [],
    deletedBeneficiados: [],
    // Accordion
    activeItem: null,
    alteracoes: false,
    diaRegistroAtual: null,
  }),
  watch: {
    selectedDate: function () {
      let val = this.selectedDate.split("-");
      val = val[2]+"/"+val[1]+"/"+val[0];
      const selectedDate = moment(val, "DD/MM/YYYY");
      const endMonth = moment(selectedDate).endOf("month");
      const validPeriod = moment(endMonth).add(5, "days");
      const now = moment();
      if (
        !now.isSameOrBefore(validPeriod, "day") ||
        !now.isSameOrAfter(selectedDate, "day")
      ) {
        this.$toast.info("Você não pode fazer alterações na data selecionada.");
      }
    },
  },
  computed: {
    canMakeChanges() {
      let dateValid = false;
      if (this.selectedDate) {
        let val = this.selectedDate.split("-");
        val = val[2]+"/"+val[1]+"/"+val[0];
        const selectedDate = moment(val, "DD/MM/YYYY");
        const endMonth = moment(selectedDate).endOf("month");
        const validPeriod = moment(endMonth).add(5, "days");
        const now = moment();
        if (
          now.isSameOrBefore(validPeriod, "day") &&
          now.isSameOrAfter(selectedDate, "day")
        ) {
          dateValid = true;
        }
      }

      return (
        dateValid &&
        this.estabelecimentoEntity &&
        this.estabelecimentoEntity.cod_estabelecimento
      );
    },
    disableSaveButton() {
      return (
        !this.alteracoes ||
        this.selectedDate === null ||
        !this.estabelecimentoEntity ||
        !this.estabelecimentoEntity.cod_estabelecimento ||
        !(this.items.length || this.deletedLeite.length || this.deletedBeneficiados.length)
      );
    },
  },
  methods: {
    setAlterado(){
      this.alteracoes = true;
    },
    onAddItemClick() {
      const emptyItem = this.getEmptyItem();

      this.items.push(emptyItem);

      const index = this.items.length - 1;

      this.onChangeAccordion(this.items.length - 1);

      this.alteracoes = true;
    },
    onSelectDay() {
    
      let dataArray = this.selectedDate.split("-");
      let dataConv = dataArray[2]+"/"+dataArray[1]+"/"+dataArray[0];
      let data = dataArray[0]+"-"+dataArray[1]+"-"+dataArray[2];
      // console.log(data);

      if(this.alteracoes){
        let self = this;

        this.$dialog
        .confirm(`Deseja realmente carregar os registros do dia ${dataConv}? Você irá perder qualquer alteração feita nos registros do dia ${this.diaRegistroAtual.split("-").reverse().join("/")}`)
        .then((dialog) => {
          self.activeItem = null;  
          self.selectedDate = data;
          self.onLoadDayData();
          self.alteracoes = false;  
          self.diaRegistroAtual = data;
        })
        .catch((e) => {
          self.selectedDate = self.diaRegistroAtual;      
          console.log("Clicked on cancel", e);
        });

      }else{
        this.activeItem = null;  
        this.selectedDate = data;
        this.onLoadDayData();   
        this.diaRegistroAtual = data;

      } 
    },
    onLoadDayData() {
      if (
        !this.estabelecimentoEntity ||
        !this.estabelecimentoEntity.cod_estabelecimento ||
        !this.selectedDate
      ) {
        return;
      }

      this.isLoading = true;
      this.boletos = [];

      window.api
        .fetch(`/acompanhamentos/recebimento-leite/load-day-data`, {
          params: {
            date: this.selectedDate.split('-').reverse().join('/'),
            cod_pj: this.estabelecimentoEntity.cod_estabelecimento,
          },
        })
        .then((response) => {
          this.items = response.data.registers;

          this.items.forEach((item, index) => {
            const cpfCnpj = item.cpf_cnpj_produtor.replace(/[^0-9]/g, "");
            if(item.estado != "outros"){
              window.api
              .fetch(`/sidagro-api/get-produtor-and-propriedades-acompanhamentos`, {
                params: {
                  cpf_cnpj: cpfCnpj,
                },
              })
              .then((produtorResponse) => {
                const produtor = produtorResponse.data;
                item.propriedades = produtor.propriedades || [];
                this.$set(this.items, index, item);
              });
            }
          });

          if (response.data.boletos && response.data.boletos.length) {
            this.boletos = response.data.boletos;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    onInputEspecie(ev, item) {
      const selectedText = ev.target.options[ev.target.selectedIndex].innerText;
      item.nome_especie = selectedText;
    },
    onCpfCnpjBlur(item) {
      $("#div-form").LoadingOverlay("show", true);
      if(item.cpf_cnpj_produtor && item.cpf_cnpj_produtor !== ""){
        const cpfCnpj = item.cpf_cnpj_produtor && item.cpf_cnpj_produtor.replace(/[^0-9]/g, "");
        if (!cpfCnpj || cpfCnpj == "") {
          $("#div-form").LoadingOverlay("hide", true);
          return;
        }
        else if (
          (cpfCnpj.length !== 11 && cpfCnpj.length !== 14) ||
          (cpfCnpj.length === 11 && !window.cpfValidation(cpfCnpj)) ||
          (cpfCnpj.length === 14 && !window.cnpjValidation(cpfCnpj))
        ) {
          this.$toast.error("CPF/CNPJ inválido.");
          $("#div-form").LoadingOverlay("hide", true);
          item.cpf_cnpj_produtor = "";
          return;
        }
        
        if (item.estado == "outros") {
          $("#div-form").LoadingOverlay("hide", true);
          return;
        }

        item.propriedades = [];
        item.is_produtor_sidagro = false;
        item.is_adimplente_febre_aftosa = false;

        window.api
          .fetch(`/sidagro-api/get-produtor-and-propriedades-acompanhamentos`, {
            params: {
              cpf_cnpj: cpfCnpj,
            },
          })
          .then((response) => {
            $("#div-form").LoadingOverlay("hide", true);
            const produtor = response.data;

            item.is_produtor_sidagro = true;
            item.cpf_cnpj_produtor = produtor.cpf_cnpj;
            item.nome_produtor = produtor.nomeprodutor;

            item.propriedades = produtor.propriedades || [];
          }).catch((error) => {
            item.cpf_cnpj_produtor = "";
            $("#div-form").LoadingOverlay("hide", true);
          });
      }
      else if(item.cnpj_fabricante && item.cnpj_fabricante !== "") {
        const cnpj = item.cnpj_fabricante && item.cnpj_fabricante.replace(/[^0-9]/g, "");
        if (
          (cnpj.length !== 14) ||
          (cnpj.length === 14 && !window.cnpjValidation(cnpj))
        ) {
          this.$toast.error("CNPJ inválido.");
          $("#div-form").LoadingOverlay("hide", true);
          item.cnpj_fabricante = "";
          return;
        }
        $("#div-form").LoadingOverlay("hide", true);
      }else{
        $("#div-form").LoadingOverlay("hide", true);
      }
    },
    onChangePropriedade(item) {
      $("#div-form").LoadingOverlay("show", true);
      this.alteracoes = true;
      const cpfCnpj =
        item.cpf_cnpj_produtor && item.cpf_cnpj_produtor.replace(/[^0-9]/g, "");

      if (!item.cod_propriedade || !cpfCnpj) {
        $("#div-form").LoadingOverlay("hide", true);
        return;
      }

      window.api
        .fetch(`/sidagro-api/adimplente-ultimas2-campanhas-aftosa`, {
          params: {
            cpf_cnpj: cpfCnpj,
            cod_propriedade: item.cod_propriedade,
          },
        })
        .then((response) => {
          $("#div-form").LoadingOverlay("hide", true);
          const isAdimplente = response.data;
          item.is_adimplente_febre_aftosa = isAdimplente;

          if (!isAdimplente) {
            this.$toast.error(
              "Você não pode receber desse produtor, pois ele não está adimplente com as duas ultimas campanhas de vacinação de Febre Aftosa"
            );
          }
        });
    },
    onChangeAccordion(index) {
      if (this.activeItem === index) {
        this.activeItem = null;
        return;
      }

      this.activeItem = index;

      const beforeIndex = index == 0 ? index : index - 1;
      const accordionItem = document.getElementById("accordion-" + beforeIndex);
      const topPos = $(accordionItem).offset().top;
      $("html, body").animate(
        {
          scrollTop: topPos,
        },
        1000
      );
    },
    onDeleteClick(ev, index) {
      ev.preventDefault();
      ev.stopPropagation();

      const item = this.items[index];
      
      this.$dialog
        .confirm("Deseja realmente apagar este ítem?")
        .then((dialog) => {
          $("#div-form").LoadingOverlay("show", true);
          let self = this;
          const formData = new FormData();

          if (item.cod_ac_leite) {
            formData.set("deletedIdLeite", item.cod_ac_leite);
          }
          if (item.cod_ac_beneficiados) {
          formData.set("deletedIdBeneficiados", item.cod_ac_beneficiados);
          }

          window.api
          .fetch("/acompanhamentos/recebimento-leite/deletar", {
            method: "post",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            $("#div-form").LoadingOverlay("hide", true);
            console.log(index);
            console.log(self.items);
            console.log(self.items[index]);
            self.items.splice(index, 1);

            $.jAlert({
              title: "Aviso",
              content: response.message,
              theme: "green",
            });

            setTimeout(function () {
            $("#div-form").LoadingOverlay("hide", true);

            }, 1000);
          });
        })
        .catch((e) => {
          $("#div-form").LoadingOverlay("hide", true);
          console.log("Clicked on cancel", e);
        });
    },
    onSaveClick() {
      $("#div-form").LoadingOverlay("show", true);
      let hasError = false;
      this.$el.querySelectorAll(".form-group.required").forEach((node) => {
        const formControl = node.querySelector(".form-control");
        if (!formControl.value) {
          node.classList.add("error");
          hasError = true;
          console.log(node);
        } else {
          node.classList.remove("error");
        }
      });

      if (hasError) {
        this.$toast.error("Preencha os campos obrigatórios.");
        $("#div-form").LoadingOverlay("hide", true);
        return;
      }

      const formData = new FormData();
      formData.set("data", JSON.stringify(this.items));

      window.api
        .fetch("/acompanhamentos/recebimento-leite/salvar", {
          method: "post",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          $("#div-form").LoadingOverlay("hide", true);
          $.jAlert({
            title: "Aviso",
            content: response.message,
            theme: "green",
          });

          setTimeout(function () {
            location.reload();
          }, 1000);
        });
    },
    getEmptyItem() {
      return {
        cod_ac_leite: null,
        cod_estabelecimento: this.estabelecimentoEntity.cod_estabelecimento,
        data: this.selectedDate.indexOf('-') == -1 ? this.selectedDate.split("/").reverse().join("-") : this.selectedDate,
        cod_especie: "",
        nome_especie: "",
        is_produtor_sidagro: false,
        is_adimplente_febre_aftosa: false,
        estado: "ceara",
        produto: "",
        tipo_registro: "",
        numero_registro: "",
        tipo_produto: "",
        cnpj_fabricante: null,
        cpf_cnpj_produtor: null,
        nome_produtor: null,
        cod_propriedade: "",
        nome_propriedade: "",
        qtd_recebida: null,
        observations: null,
        naoConforme: [],
        // derivadas: [],
      };
    },
    getDerivadasOptions() {
      return {
        leiteEvaporado: "LEITE EVAPORADO (KG)",
        leiteCondensado: "LEITE CONDENSADO (KG)",
        doceDeLeite: "DOCE DE LEITE (KG)",
        leiteEmPo: "LEITE EM PÓ (KG)",
        outrasMaterias: "OUTRAS MATÉRIAS PRIMAS (KG)",
      };
    },
    naoConformidadeOptions(produto) {
      if(!produto) produto=0;
      var temp = this.dadosLeite.naoconformidades.filter(nc=> nc.cod_beneficiado == produto)
      // console.log(temp)
      // var temp2 = temp.map(item => {
      //   return {
      //     cod: item.cod_nao_conformidade,
      //     nome: item.nome
      //   };
      // });
      // console.log(temp2);
      return temp
    },
    pesquisar(){
      if(this.alteracoes){
        this.$dialog
          .confirm("Deseja realmente voltar para a pesquisa? Todas as alterações serão perdidas!")
          .then((dialog) => {
            cadastro.pesquisar()
          })
          .catch((e) => {    
            console.log("Clicked on cancel", e);
          });
      }else{
        cadastro.pesquisar()
      }
    },
  },
  mounted() {
    if (Object.keys(this.estabelecimento).length) {
      this.estabelecimentoEntity = {
        estabelecimento: this.estabelecimento.nome,
        sie_estabelecimento: this.estabelecimento.num_sie + ' - ' + this.estabelecimento.nome,
        cod_estabelecimento: this.estabelecimento.cod_estabelecimento,
      };
    }

    this.estabelecimentos.map(function (x){
      return x.sie_estabelecimento = x.num_sie + ' - ' + x.estabelecimento;
    });

    window.api
        .fetch(
          "/acompanhamentos/recebimento-leite/load-form-data",
          {
            method: "get",
            headers: { "Content-Type": "multipart/form-data" },
          }
        )
        .then((response) => {
          this.dadosLeite = response.data;
          // console.log(this.dadosLeite); // remove
        })
        .catch((error) => {
          this.$toast.error(
              "Erro ao buscar dados."
            );
        });
  },
};
</script>
<style lang="scss" scoped>
.sida-accordion .item .content {
  background: #f3f3f3;
}

.container {
  .no-data-found {
    padding: 100px 16px;
  }
}
</style>
